// extracted by mini-css-extract-plugin
export default {"separator":"separatorLine_separator__XVQwb","dot":"separatorLine_dot__99zrz"};